<template>
  <section>
    <div class="personal-center-form__section">

      <div v-if="Number(userInfo.crmCustomerType) === 1">
        <h1 class="personal-center-form__title">实名认证</h1>
        <div class="personal-center-form__main">
          <el-row :gutter="0" class="personal-center-form__form" style="padding-bottom:0;">
            <el-col :span="16">
              <el-form :label-width="'50%'" :model="realAuthFormModel" :rules="rules" ref="realAuthForm">
                <el-form-item label="银行卡号" prop="cardno">
                  <el-select placeholder="请选择银行卡号" :style="{width: '100%'}" v-model="realAuthFormModel.cardno">
                    <el-option v-for="item in bankList" :key="item.bankAccountName" :label="item.bankAccountName"
                               :value="item.bankAccountName"
                               @click.native="selectCardNO(item.bankAccountName)"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="银行预留手机号" prop="mobile">
                  <el-input placeholder="请输入手机号" v-model="realAuthFormModel.mobile" :maxlength="11"
                            :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="姓名" prop="name">
                  <el-input placeholder="请输入姓名" v-model="realAuthFormModel.name" :disabled="isEditable"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="idno">
                  <el-input placeholder="请输入身份证号码" v-model="realAuthFormModel.idno" :disabled="isEditable"
                            :maxlength="IDMaxLength"></el-input>
                </el-form-item>
                <div v-if="!isAuth">
                 <!-- <el-form-item label="签约号码" prop="proNumber">
                    <el-input placeholder="请输入您的签约号" v-model="realAuthFormModel.proNumber"
                              :disabled="stateCode === 3 ? true : false" :maxlength="16"></el-input>
                  </el-form-item>-->
                  <el-form-item label="短信验证码" prop="SMSCode" class="SMS-cont">
                    <el-input placeholder="请输入短信验证码" v-model="realAuthFormModel.SMSCode"
                              :disabled="!SMSCodeBtn.btnState" :maxlength="6"></el-input>
                    <el-button type="primary" size="mini" class="el-button-sms-code" @click="getSMSCode"
                               :disabled="stateCode === 3 ? true : SMSCodeBtn.btnState">{{SMSCodeBtn.text}}
                    </el-button>
                  </el-form-item>
                </div>
              </el-form>
            </el-col>
          </el-row>
          <div class="tips_info el-icon-information">如有信息出错，请联系管理员修改</div>
          <div class="text-center">
            <el-button type="primary" :loading="isSaving" class="personal-center-form__submit" @click="submitForm"
                       v-if="stateCode !== 3">提交
            </el-button>
            <el-button type="primary" :loading="isSaving" class="personal-center-form__alreadyAuth"
                       :disabled="stateCode === 3" @click="submitForm" v-else>已实名认证
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="Number(userInfo.crmCustomerType) === 2">
        <h1 class="personal-center-form__title">企业认证</h1>
        <div class="personal-center-form__main">
          <el-row :gutter="0" class="personal-center-form__form" style="padding-bottom:0;">
            <el-col :span="16">
              <el-form :label-width="'50%'" :model="enterpriseInfoFormModel" :rules="rules" ref="realAuthForm">
                <el-form-item label="客户名称" :required="true" prop="customerName">
                  <el-input type="text" placeholder="请输入客户名称" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.customerName"></el-input>
                </el-form-item>
                <el-form-item label="营业执照号" :required="true" prop="enterpriseNumber">
                  <el-input type="text" placeholder="请输入营业执照号" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseNumber"></el-input>
                </el-form-item>
                <el-form-item label="注册人类型" :required="true" prop="userType">
                  <el-radio-group v-model="enterpriseInfoFormModel.userType" :disabled="isEditable">
                    <el-radio :label="2">法人注册</el-radio>
                    <el-radio :label="1">代理人注册</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="Number(enterpriseInfoFormModel.userType) === 2 ? '法定代表人' : '代理人'" :required="true" prop="enterpriseLegalUser">
                  <el-input type="text" :placeholder="Number(enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人' : '请输入代理人'" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseLegalUser"></el-input>
                </el-form-item>
                <el-form-item :label="Number(enterpriseInfoFormModel.userType) === 2 ? '法定代表人身份证号' : '代理人身份证号'" :required="true" prop="enterpriseLegalIdNo">
                  <el-input type="text" :placeholder="Number(enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人身份证号' : '请输入代理人身份证号'" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseLegalIdNo"></el-input>
                </el-form-item>
                <el-form-item :label="Number(enterpriseInfoFormModel.userType) === 2 ? '法人联系电话':'代理人联系电话'" :required="true" prop="enterpriseLegalUserPhone">
                  <el-input type="tel" :placeholder="Number(enterpriseInfoFormModel.userType) === 2 ?'请输入法人联系电话':'请输入法人联系电话'" :disabled="isEditable" :maxlength="11"
                            v-model="enterpriseInfoFormModel.enterpriseLegalUserPhone"></el-input>
                </el-form-item>
                <el-form-item label="企业注册类型" :required="true" prop="registrationType">
                  <el-radio-group v-model="enterpriseInfoFormModel.registrationType" :disabled="isEditable">
                    <el-radio :label="0">组织机构代码证号</el-radio>
                    <el-radio :label="1">多证合一</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="Number(enterpriseInfoFormModel.registrationType) === 0?'组织机构代码证号':'社会信用代码号'" :required="true" prop="enterpriseOrganizingNumber">
                  <el-input type="text" :placeholder="Number(enterpriseInfoFormModel.registrationType) === 0?'请输入组织机构代码证号':'请输入社会信用代码号'" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseOrganizingNumber"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <div class="tips_info el-icon-information">如有信息出错，请联系管理员修改</div>
          <div class="tips_info el-icon-information" v-if="approvalInfo !== ''">{{approvalInfo}}</div>
          <div class="text-center">
            <el-button type="primary" :loading="isSaving" class="personal-center-form__submit" @click="submitForm"
                       v-if="stateCode == 0">提交
            </el-button>
            <el-button type="primary" :loading="isSaving" class="personal-center-form__alreadyAuth"
                       :disabled="stateCode === 2" @click="submitForm" v-if="stateCode == 2">已提交
            </el-button>
            <el-button type="primary" :loading="isSaving" class="personal-center-form__alreadyAuth"
                       :disabled="stateCode === 3" @click="submitForm" v-if="stateCode == 3">已认证
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import api from '../../vuex/api'
  import _ from 'lodash'

  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import * as types from '../../vuex/types'

  export default {
    data () {
      const assignValidator = (type, trigger = 'blur') => Object.assign({
        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options})
        }
      })
      return {
        indexCode: '',
        IDMaxLength: 18,
        isEditable: true,
        isSaving: false,
        isAuth: true,
        rules: {
          cardno: [{required: true, message: '请选择银行卡号', trigger: 'change'}],
          mobile: [assignValidator(types.VERIFY_CELLPHONE)],
          name: [assignValidator((types.VERIFY_CHN_NAME))],
          idno: [assignValidator(types.VERIFY_ID_CARD_NUM)],
          enterpriseNumber: [assignValidator(types.VERIFY_ENTERPRISE_NUMBER)],
          SMSCode: [{required: true, message: '请输入收到的短信验证码', trigger: 'blur'}],
          enterpriseLegalUser: [assignValidator((types.VERIFY_CHN_NAME))],
          enterpriseLegalUserPhone: [assignValidator(types.VERIFY_CELLPHONE)],
          enterpriseLegalIdNo: [assignValidator(types.VERIFY_ID_CARD_NUM)],
          proNumber: [
            {
              required: true,
              trigger: 'blur',

              validator: (rules, value, callback) => {
                if (_.trim(value) === '') {
                  callback(new Error('签约号不能为空'))
                }
                callback()
              }
            }

          ],
          customerName: [{
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('客户名称不能为空'))
              } else {
                callback()
              }
            }
          }],
          enterpriseOrganizingNumber: [{
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('组织机构代码证号不能为空'))
              } else {
                callback()
              }
            }
          }],
          userType: [{
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择'))
              } else {
                callback()
              }
            }
          }]
        },
        SMSCodeBtn: {
          btnState: false,
          text: '获取验证码'

        },
        enterpriseInfoFormModel: {
          authId: '',
          customerName: '',
          enterpriseNumber: '',
          enterpriseLegalUser: '',
          enterpriseLegalUserPhone: '',
          enterpriseLegalIdNo: '',
          userType: 2,
          registrationType: 0,
          enterpriseOrganizingNumber: ''
        },
        approvalInfo: ''
      }
    },
    computed: {
      ...mapGetters({
        myInfo: types.GET_MY_INFO,
        userInfo: types.GET_USER,
        realAuthFormModel: types.GET_REAL_NAME_AUTH_ALL_INFO,
        bankList: types.GET_BANK_LIST,
        stateCode: types.GET_REAL_NAME_STATE
      })
    },
    methods: {
      ...mapMutations({
        setRealNameAuthInfo: types.SET_REAL_NAME_AUTH_ALL_INFO,
        setBankList: types.SET_BANK_LIST,
        updateBankCardNum: types.UPDATE_BANK_CARD_NUM,
        setRealNameState: types.SET_REAL_NAME_STATE
      }),
      ...mapActions({
        getRealNameAuthData: types.GET_REAL_NAME_AUTH_DATA,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),
      submitForm () {
        this.$refs.realAuthForm.validate((valid) => {
          if (valid) {
            this.loading = true
            if (Number(this.userInfo.crmCustomerType) === 1) {
              api.authPersonSignAgreement({
                proNumber: this.realAuthFormModel.proNumber,
                bankAccount: this.realAuthFormModel.cardno,
                bankAccountOwner: this.realAuthFormModel.name,
                idCard: this.realAuthFormModel.idno,
                customerId: this.userInfo.crmCustomerId,
                vCode: this.realAuthFormModel.SMSCode,
                indexCode: this.indexCode,
                token: this.userInfo.token
              }).then((res) => {
                if (Number(res.data.code) === 0) {
                  this.setRealNameState(2)
                  this.loading = false
                  this.setSuccessMessage({
                    show: true,
                    content: res.data.result
                  })
                } else {
                  this.setRealNameState(0)
                  this.setFailMessage({
                    show: true,
                    content: res.data.result
                  })
                }
              }).catch((res) => {
                this.loading = false
              })
            } else if (Number(this.userInfo.crmCustomerType) === 2) {
              api.saveEnterpriseAuthInfo({
                token: this.userInfo.token,
                authId: this.enterpriseInfoFormModel.authId,
                customerId: this.userInfo.crmCustomerId,
                customerName: this.enterpriseInfoFormModel.customerName,
                enterpriseNumber: this.enterpriseInfoFormModel.enterpriseNumber,
                enterpriseLegalUser: this.enterpriseInfoFormModel.enterpriseLegalUser,
                enterpriseLegalIdNo: this.enterpriseInfoFormModel.enterpriseLegalIdNo,
                enterpriseLegalUserPhone: this.enterpriseInfoFormModel.enterpriseLegalUserPhone,
                enterpriseOrganizingNumber: this.enterpriseInfoFormModel.enterpriseOrganizingNumber,
                userType: this.enterpriseInfoFormModel.userType,
                registrationType: this.enterpriseInfoFormModel.registrationType
              }).then((res) => {
                if (Number(res.data.code) === 1) {
                  this.setRealNameState(2)
                  this.setSuccessMessage({
                    show: true,
                    content: res.data.result
                  })
                } else {
                  this.setRealNameState(0)
                  this.setFailMessage({
                    show: true,
                    content: res.data.result
                  })
                }
              })
            }
          } else {
            return false
          }
        })
      },

      gotoLoan (text) {
        const that = this

        this.$alert(text, ' ', {
          confirmButtonText: '确定',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            that.$router.push({path: '/personalCenter/myLoan'})
            done()
          }
        })
      },
      selectCardNO (curr) {
        this.updateBankCardNum(curr)
      },
      getSMSCode () {
        // 由于签约号规则还没有确定
        this.$refs.realAuthForm.validateField('cardno')
        this.$refs.realAuthForm.validateField('mobile')
        this.$refs.realAuthForm.validateField('name')
        this.$refs.realAuthForm.validateField('idno')
        // this.$refs.realAuthForm.validateField('proNumber')
        setTimeout(() => {
          const error = document.querySelectorAll('.el-form-item__error')
          if (error.length <= 0) {
            api.authPersonSMSCode({
              token: this.userInfo.token,
              customerId: this.userInfo.crmCustomerId,
              // proNumber: this.realAuthFormModel.proNumber,
              mobile: this.realAuthFormModel.mobile,
              bankAccount: this.realAuthFormModel.cardno,
              bankAccountOwner: this.realAuthFormModel.name,
              idno: this.realAuthFormModel.idno,
              msgType: 0
            }).then((res) => {
              const resData = res.data
              this.indexCode = resData.data
              let countDownTime = 60
              if (Number(resData.code) === 0) {
                const countDown = setInterval(() => {
                  countDownTime -= 1
                  if (countDownTime !== 0) {
                    this.SMSCodeBtn = {
                      btnState: true,
                      text: `After ${countDownTime} seconds`
                    }
                  } else {
                    this.SMSCodeBtn = {
                      btnState: false,
                      text: '获取验证码'
                    }
                    clearInterval(countDown)
                  }
                }, 1000)
              } else {
                this.setFailMessage({
                  show: true,
                  content: resData.result
                })
              }
            })
          }
        }, 500)
      }
    },
    mounted () {
      if (Number(this.userInfo.crmCustomerType) === 1) {
        this.getRealNameAuthData({
          token: this.userInfo.token
        }).then((res) => {
          const data = res.data
          this.setRealNameState(Number(data.code))
          if (Number(data.code) === 0 || Number(data.code) === 3) {
            if (Number(data.result.isAuth) !== 1) {
              this.isAuth = false
            }
//            设置默认选中第一张银行卡
            res.data.result.BankAuthApply.cardno = res.data.result.bankList.length > 0 ? res.data.result.bankList[0].bankAccountName : ''
            this.setRealNameAuthInfo(res.data.result.BankAuthApply)
            this.setBankList(res.data.result.bankList)
            if (Number(data.result.bankAccountIsAuthentication) === 1) {
              this.updateBankCardNum(data.result.bankAccountName)
            }
          }
//          else {
//            this.gotoLoan('请先申请贷款，审批通过后再进行实名认证！')
//          }
        })
      } else if (Number(this.userInfo.crmCustomerType) === 2) {
        api.getEnterpriseAuthInfo({
          token: this.userInfo.token
        }).then((res) => {
          const result = res.data
          const data = res.data.data
          this.setRealNameState(Number(result.code))
          if (Number(result.code) === 0 || Number(result.code) === 3 || Number(result.code) === 2) {
            if (Number(data.payReqEntity.isAuth) !== 1) {
              this.isAuth = false
            }
            this.enterpriseInfoFormModel = {
              authId: (data.payReqEntity.authId != null ? data.payReqEntity.authId : ''),
              customerName: (data.payReqEntity.customerName != null ? data.payReqEntity.customerName : ''),
              enterpriseNumber: (data.payReqEntity.enterpriseNumber != null ? data.payReqEntity.enterpriseNumber : ''),
              enterpriseLegalUser: (data.payReqEntity.enterpriseLegalUser != null ? data.payReqEntity.enterpriseLegalUser : ''),
              enterpriseLegalIdNo: (data.payReqEntity.enterpriseLegalIdNo != null ? data.payReqEntity.enterpriseLegalIdNo : ''),
              enterpriseLegalUserPhone: (data.payReqEntity.enterpriseLegalUserPhone != null ? data.payReqEntity.enterpriseLegalUserPhone : ''),
              userType: (data.payReqEntity.userType != null ? Number(data.payReqEntity.userType) : 2),
              registrationType: (data.payReqEntity.registrationType != null ? Number(data.payReqEntity.registrationType) : 0),
              enterpriseOrganizingNumber: (data.payReqEntity.enterpriseOrganizingNumber != null ? data.payReqEntity.enterpriseOrganizingNumber : '')
            }
            if (data.payReqEntity.approvalInfo !== null && data.payReqEntity.approvalInfo !== '') {
              this.approvalInfo = data.payReqEntity.approvalInfo
            }
            if (Number(result.code) === 2) {
              this.setRealNameState(2)
            }
          }
//          else if (Number(result.code) === 1) {
//            this.gotoLoan(result.result)
//          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .personal-center-form__alreadyAuth {
    margin-bottom: 25px;
    height: 40px;
    background: $lightWaterBlue;
  }

  .personal-center-form__alreadyAuth.is-disabled, .personal-center-form__alreadyAuth.is-disabled:hover {
    color: #fff;
    background-color: #c6c6c6;
  }

  //短信验证码
  .SMS-cont {
    position: relative;

    .el-button-sms-code {
      background: #00C0FF;
      position: absolute;
      right: 7px;
      top: 7px;
    }

    .el-button-sms-code.is-disabled {
      background: #DCDCDC;
    }
  }
</style>




// WEBPACK FOOTER //
// RealNameAuth.vue?648bd7ec